module.exports = __webpack_public_path__ + "static/img/p1-r-0.f65f921.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-r-0.png
// module id = zZZH
// module chunks = 0